import NFT from "./app/nft.js"
import Web3 from "./app/web3.js"


const Ethereum = {Web3, NFT };

if (window){
    if (!window.ProveAnything){
        window.ProveAnything = {}
    }
    window.ProveAnything.Ethereum = Ethereum
}

export default Ethereum
